import logger from "./logger";
import { thunk } from "redux-thunk"; // Corrigido importação de thunk

const middleware = [thunk];

if (process.env.NODE_ENV !== "production") {
  middleware.push(logger);
}

export default middleware; // Exporta como array, não aplicar aqui
